var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeleteMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "14px",
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-delete-media") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Media-library-V2",
    transform: "translate(-699.000000, -423.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M701.800001,424.4 L703.200001,423 L706.000001,423 L707.400001,424.4 L710.200001,424.4 L710.200001,425.8 L699.000001,425.8 L699.000001,424.4 L701.800001,424.4 Z M699.700001,427.2 L709.500001,427.2 L708.800001,437 L700.400001,437 L699.700001,427.2 Z M703.200001,428.6 L703.200001,435.6 L703.900001,435.6 L703.900001,428.6 L703.200001,428.6 Z M705.300001,428.6 L705.300001,435.6 L706.000001,435.6 L706.000001,428.6 L705.300001,428.6 Z",
    id: "icon-delete-media"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteMedia);
export default __webpack_public_path__ + "static/media/icon-delete-media.009a017a4e86528b49fd46eafe5d8760.svg";
export { ForwardRef as ReactComponent };